var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fade-transition", [
    _c(
      "div",
      { staticClass: "c-process-step", attrs: { id: "step-" + _vm.id } },
      [
        _vm.number
          ? _c(
              "div",
              {
                staticClass:
                  "c-process-step__wrapper t-margin-top-s t-margin-right-s t-margin-bottom-s"
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "c-process-step__circle",
                    class: {
                      "c-process-step-hide__circle":
                        this.status === "Unpublished"
                    }
                  },
                  [
                    _c(
                      "span",
                      { staticClass: "c-process-step-circle__numbers" },
                      [_vm._v(_vm._s(_vm.number))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c("span", {
                  staticClass: "c-process-step__line",
                  class: {
                    "c-process-step__hide": this.status === "Unpublished"
                  }
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "c-process-step__container c-buffer-box c-buffer-box--border-all t-margin-top-s t-margin-bottom-s",
            class: {
              "t-background-white-grey t-border-green":
                _vm.mode == "create" || _vm.mode == "edit",
              "c-process-step-hide__border": this.status === "Unpublished"
            }
          },
          [
            _c(
              "div",
              { staticClass: "c-process-step__header" },
              [
                _vm.mode === "view"
                  ? [
                      _c(
                        "div",
                        [
                          _c("h1", { staticClass: "t-text-style-beta" }, [
                            _vm._v(_vm._s(_vm.name))
                          ]),
                          _vm._v(" "),
                          _c(
                            "can",
                            { attrs: { i: "manage", a: _vm.processType } },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "c-button c-button--linkstyle c-button--reset",
                                  attrs: { type: "button" },
                                  on: { click: _vm.goToEditMode }
                                },
                                [
                                  _c("vue-icon", {
                                    attrs: {
                                      name: "edit",
                                      size: "c-icon--17px"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "c-button__title" },
                                    [_vm._v("Ändra processteg")]
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.mode == "edit"
                  ? _c("div", [
                      _c(
                        "h1",
                        { staticClass: "t-text-style-beta t-margin-bottom-s" },
                        [_vm._v("Ändra processteg")]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "can",
                  { attrs: { i: "manage", a: _vm.processType } },
                  [
                    _vm.mode === "edit" || _vm.status === "Unpublished"
                      ? _c("toggle-status", {
                          attrs: {
                            type: "process-step",
                            status: _vm.status,
                            "process-id": _vm.processId
                          },
                          on: {
                            publish: _vm.publishStep,
                            unpublish: _vm.unpublishStep
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ],
              2
            ),
            _vm._v(" "),
            _vm.mode === "view"
              ? _c("div", {
                  staticClass:
                    "t-margin-bottom-sm t-margin-top-s s-text s-text--vue",
                  domProps: { innerHTML: _vm._s(_vm.description) }
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "can",
              { attrs: { i: "manage", a: _vm.processType } },
              [
                _vm.mode == "create" || _vm.mode == "edit"
                  ? [
                      _vm.mode == "create"
                        ? _c(
                            "h1",
                            {
                              staticClass: "t-text-style-beta t-margin-bottom-s"
                            },
                            [_vm._v("Skapa processteg")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          staticClass: "c-form",
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.handleSubmit($event)
                            }
                          }
                        },
                        [
                          _c(
                            "fieldset",
                            [
                              _c(
                                "div",
                                { staticClass: "c-form__item" },
                                [
                                  _c("vue-input", {
                                    ref: "name",
                                    attrs: {
                                      label: "Namn på processteg",
                                      "input-id": "name",
                                      value: _vm.name
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "c-form__item" },
                                [
                                  _c("vue-input", {
                                    ref: "description",
                                    attrs: {
                                      label: "Beskrivning",
                                      "input-id": "description",
                                      value: _vm.description,
                                      type: "textarea"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.mode === "create"
                                ? [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "c-button c-button--primary t-margin-top-s",
                                        attrs: { type: "submit" },
                                        on: {
                                          click: function($event) {
                                            return _vm.setSubmitType("create")
                                          }
                                        }
                                      },
                                      [_vm._v("Skapa processteg")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "c-button c-button--linkstyle c-button--reset",
                                        attrs: { type: "button" },
                                        on: {
                                          click: _vm.cancelCreateProcessStep
                                        }
                                      },
                                      [_vm._v("Avbryt")]
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.mode === "edit"
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "t-space-between" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "t-margin-bottom-s" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "c-button c-button--primary",
                                                attrs: { type: "submit" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.setSubmitType(
                                                      "edit"
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("Spara ändringar")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "c-button c-button--linkstyle c-button--reset",
                                                attrs: { type: "button" },
                                                on: {
                                                  click:
                                                    _vm.cancelEditProcessStep
                                                }
                                              },
                                              [_vm._v("Avbryt")]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "c-button c-button--linkstyle c-button--linkstyle__secondary c-button--reset t-margin-bottom-s",
                                            attrs: { type: "submit" },
                                            on: {
                                              click: _vm.toggleDeleteStepModal
                                            }
                                          },
                                          [
                                            _c("vue-icon", {
                                              attrs: {
                                                name: "delete",
                                                size: "c-icon--17px"
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "c-button__title"
                                              },
                                              [_vm._v("Ta bort processteg")]
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "modal",
                                      {
                                        attrs: {
                                          show: _vm.showDeleteStepModal
                                        },
                                        on: {
                                          closeModal: _vm.toggleDeleteStepModal
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "c-modal__content t-background-white t-text-align-center"
                                          },
                                          [
                                            _c(
                                              "h1",
                                              {
                                                staticClass:
                                                  "t-text-style-alpha t-margin-bottom-s"
                                              },
                                              [
                                                _vm._v(
                                                  'Du tar nu bort processteget "' +
                                                    _vm._s(this.name) +
                                                    '"'
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "form",
                                              {
                                                staticClass: "c-form",
                                                on: {
                                                  submit: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.handleSubmit(
                                                      $event
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "c-button c-button--linkstyle c-button--reset t-margin-top-m",
                                                    on: {
                                                      click:
                                                        _vm.toggleDeleteStepModal
                                                    }
                                                  },
                                                  [_vm._v("Avbryt")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "c-button c-button--primary t-margin-top-s",
                                                    attrs: { type: "submit" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.setSubmitType(
                                                          "delete"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Ta bort")]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm.mode === "view"
              ? _c("resources-data-provider", {
                  attrs: {
                    "process-id": _vm.processId,
                    "process-step-id": _vm.id
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(dataProvider) {
                          return _c("resources", {
                            attrs: {
                              "process-id": _vm.processId,
                              "process-step-id": _vm.id,
                              "show-create": dataProvider.showCreate,
                              resources: dataProvider.resources,
                              "process-type": _vm.processType
                            },
                            on: {
                              setShowCreate: dataProvider.setShowCreate,
                              createResource: dataProvider.createResource,
                              editResource: dataProvider.editResource,
                              deleteResource: dataProvider.deleteResource,
                              sortResources: dataProvider.sortResources
                            }
                          })
                        }
                      }
                    ],
                    null,
                    false,
                    3183390125
                  )
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.mode !== "create"
          ? _c("can", { attrs: { i: "manage", a: _vm.processType } }, [
              _c("div", { staticClass: "c-process-step__sorting" }, [
                _c(
                  "form",
                  {
                    staticClass: "c-form",
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.handleSubmit($event)
                      }
                    }
                  },
                  [
                    _vm.sortIndex !== _vm.sortIndexes[0]
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "c-button c-button--linkstyle c-button--reset c-process-step__move-up",
                            attrs: { title: "Flytta upp", type: "submit" },
                            on: {
                              click: function($event) {
                                return _vm.setSubmitType("moveUp")
                              }
                            }
                          },
                          [
                            _c("vue-icon", {
                              attrs: { name: "expand", size: "c-icon--17px" }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.sortIndex !==
                    _vm.sortIndexes[_vm.sortIndexes.length - 1]
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "c-button c-button--linkstyle c-button--reset",
                            attrs: { title: "Flytta ner", type: "submit" },
                            on: {
                              click: function($event) {
                                return _vm.setSubmitType("moveDown")
                              }
                            }
                          },
                          [
                            _c("vue-icon", {
                              attrs: { name: "expand", size: "c-icon--17px" }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ])
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }